import { ProposalsFilterData, ProposalsListingRouteInfo} from "./types";
import { iRootState, iRootDispatch } from "../../store";
import { FormikProps, withFormik } from "formik";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import {AvailableBrokersAndEstatesState} from "../../store/types/temp-types";
import BondInsuranceProposalsPage from "./components/BondInsuranceProposalsPage";

const mapState = (state: iRootState) => ({
  availableBrokersAndEstates: state.availableBrokersAndEstates,
  user: state.user
});

const mapDispatch = (dispatch: iRootDispatch) => ({
  updateAvailableBrokersAndEstates: (availableBrokers: AvailableBrokersAndEstatesState) => dispatch.availableBrokersAndEstates.updateAvailableBrokersAndEstates(availableBrokers),
})

export type BondInsuranceProposalsListProps = ReturnType<typeof mapDispatch>
  & ReturnType<typeof mapState>
  & FormikProps<ProposalsFilterData>
  & RouteComponentProps<ProposalsListingRouteInfo>;

const BondInsuranceProposalsForm = withFormik<BondInsuranceProposalsListProps, ProposalsFilterData>({

  mapPropsToValues: () => {
    return {
      broker_id: '',
      estate_id: '',
      user_id: ''
    }
  },

  validationSchema: {},

  handleSubmit: () => {
  },

})(BondInsuranceProposalsPage);

export default connect(mapState, mapDispatch)(BondInsuranceProposalsForm);
